// extracted by mini-css-extract-plugin
export default {"orderTopHeader":"SimpleHeader_orderTopHeader__UEE9O","logo":"SimpleHeader_logo__7A1ft"};